export default "__VITE_ASSET__DMBU9irF__"